var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBfIconPpc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50,0a50,50,0,1,0,50,50A50,50,0,0,0,50,0ZM24.53,35.74A19.13,19.13,0,1,1,58.37,48a3.66,3.66,0,0,0-2.51-1,4.38,4.38,0,0,0-.87.1,3.91,3.91,0,0,0-2.56,1.84,4.11,4.11,0,0,0-.58,2l-.65-2.51a14.73,14.73,0,1,0-8.31,2.06L44,54.86h-.31A19.12,19.12,0,0,1,24.53,35.74ZM43.66,30a5.76,5.76,0,0,0-3.2,10.56l1.27,5.18a10.18,10.18,0,1,1,8.24-2l-1.32-5.07a5.76,5.76,0,0,0-5-8.64ZM75.38,73.54c-1.15,4.57-2.7,8.47-10.06,10.09S52.67,83.7,47,78.26c-3.27-3.17-6-10.6-2.89-15,.34-.48.65-.87.91-1.17l1.7,7a1,1,0,0,0,2-.49L41.83,40a2.78,2.78,0,1,1,5.39-1.15l4.3,16.46a1,1,0,0,0,1.15.76A1,1,0,0,0,53.55,55l-.16-3.14a.88.88,0,0,0,0-.17,2.61,2.61,0,0,1,1.93-3.25,2.5,2.5,0,0,1,3,2.17l.45,2a1,1,0,1,0,2-.45A2.75,2.75,0,1,1,66.1,51l1,4.37a1,1,0,1,0,2-.44l-.56-2.57a4.92,4.92,0,0,1,1.57-.83,2.38,2.38,0,0,1,2.78,1.5C73.87,57.58,76.25,70.06,75.38,73.54Z",
    fill: "#03a9f4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBfIconPpc);
export default __webpack_public_path__ + "static/media/bf-icon-ppc.b4178885cf0824f3eee668d4ae414cf6.svg";
export { ForwardRef as ReactComponent };